import { CompanySitesListComponent } from './admin-dashboard/company-sites/company-sites-list/company-sites-list.component';
import { CompanySitesLayoutComponent } from './admin-dashboard/company-sites/company-sites-layout/company-sites-layout.component';
import { DetailSiteLayoutComponent } from './admin-dashboard/company-sites/detail-site-layout/detail-site-layout.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductComponent } from './admin-dashboard/product/product.component';
import { SignupComponent } from './auth/signup/signup.component';
import { SigninComponent } from './auth/signin/signin.component';
import { AuthGaurd } from './services/auth-gaurd.service';

import { DetailSiteComponent } from './admin-dashboard/company-sites/detail-site/detail-site.component';
import { SiteSystemComponent } from './admin-dashboard/site-system/site-system.component';
import { VmMachineComponent } from './admin-dashboard/vm-machine/vm-machine.component';
import { EditChannelComponent } from './admin-dashboard/vm-machine/edit-channel/edit-channel.component';
import { HelpComponentComponent } from './admin-dashboard/help-component/help-component.component';
import { TransactionViewComponent } from './admin-dashboard/site-system/records/transaction-view/transaction-view.component';
import { MembershipV2Component } from './admin-dashboard/membership-v2/membership-v2.component';
import { EmployeesGlobalComponent } from './admin-dashboard/employees-global/employees-global.component';
import { CustomerMappingComponent } from './admin-dashboard/customer-mapping/customer-mapping.component';
import { BillingComponent } from './admin-dashboard/billing/billing.component';
import { PortalAccessComponent } from './admin-dashboard/portal-access/portal-access.component';
import { ParentRefundsComponent } from './admin-dashboard/parent-refunds/parent-refunds.component';
import { DeliveryOverviewComponent } from './admin-dashboard/delivery/overview/overview.component';
import { DeliveryRoutesComponent } from './admin-dashboard/delivery/routes/routes.component';
import { DeliveryDriversComponent } from './admin-dashboard/delivery/drivers/drivers.component';
import { DeliveryDispatchComponent } from './admin-dashboard/delivery/dispatch/dispatch.component';
import { DeliveryIssuesComponent } from './admin-dashboard/delivery/issues/issues.component';
import { AuditLogsComponent } from './admin-dashboard/audit-logs/audit-logs.component';
import { KioskTabletsComponent } from './admin-dashboard/kiosk-tablets/kiosk-tablets.component';
import { StockcontrollComponent } from './admin-dashboard/site-system/inventory/stockcontroll/stockcontroll.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SiteSystemLayoutComponent } from './admin-dashboard/site-system/site-system-layout/site-system-layout.component';
import { ReportGeneratorComponent } from './admin-dashboard/report-generator/report-generator.component';
import { ReportGeneratorResultComponent } from './admin-dashboard/report-generator/report-generator-result/report-generator-result.component';
import { AdminSettingComponent } from './admin-setting/admin-setting.component';
import { StockFillerComponent } from './admin-dashboard/site-system/inventory/stock-filler/stock-filler.component';
import { SettingComponent } from './setting/setting.component';
import { InventoryComponent } from './admin-dashboard/site-system/inventory/inventory.component';
import { RecordsComponent } from './admin-dashboard/site-system/records/records.component';
import { ContactBookComponent } from './admin-dashboard/contact-book/contact-book.component';
import { PowerOfficeLogComponent } from './admin-dashboard/poweroffice-log/poweroffice-log.component';
import { TResultViewComponent } from './admin-dashboard/site-system/records/transaction-view/t-result-view/t-result-view.component';
import { ForgotComponent } from './auth/forgot/forgot.component';

import { OrdersComponent } from './admin-dashboard/orders/orders.component';
import { NotificationListComponent } from './admin-dashboard/notifications-list/notifications-list.component';
import { ActionLog } from './admin-dashboard/site-system/records/actions-log/actions-log.component';
import { PlannerComponent } from './admin-dashboard/planner/planner.component';
import { CompanyReportGeneratorComponent } from './reports/company-report-generator/company-report-generator.component';
import { CompanyReportGeneratorResultComponent } from './reports/company-report-generator/company-report-generator-result/company-report-generator-result.component';
import { MachineLog } from './admin-dashboard/site-system/records/machine-log/machine-log.component';
import { CategoryComponent } from './admin-dashboard/category/category.component';
import { SiteCategoryComponent } from './admin-dashboard/site-system/category/category.component';
import { SpecialPricesComponent } from './admin-dashboard/special-prices/special-prices.component';
import { ScheduledTaskComponent } from './admin-dashboard/scheculed-task/scheculed-task.component';
import { ReguleringComponent } from './admin-dashboard/regulering/regulering.component';
import { LinksComponent } from './admin-dashboard/site-system/inventory/links/links.component';
import { OverviewComponent } from './admin-dashboard/overview/overview.component';
import { CommonModule } from '@angular/common';
import { KantineOverviewComponent } from './admin-dashboard/overview/kantine-overview/kantine-overview.component';
import { SvinnComponent } from './admin-dashboard/site-system/inventory/svinn/svinn.component';
import { SvinnReportComponent } from './admin-dashboard/svinn-report/svinn-report.component';
import { ExtraStockcontrollComponent } from './admin-dashboard/site-system/extra-inventory/extrastockcontroll/extrastockcontroll.component';
import { SalesReportComponent } from './reports/sales-report/sales-report.component';
import { SaleReportGeneratorResultComponent } from './reports/sales-report/report-generator-result/sale-report-generator-result.component';
import { JSDLog } from './admin-dashboard/site-system/records/jsd-logs/jsd-log.component';
import { KampanjeListComponent } from './admin-dashboard/kampanje/kampanje-list.component';
import { AnnouncementListComponent } from './admin-dashboard/announcement/announcement-list.component';
import { ReportsComponent } from './reports/reports.component';
import { OrderReportComponent } from './reports/order-report/order-report.component';
import { RevenueReportComponent } from './reports/revenue-report/revenue-report.component';
import { SystemInfoComponent } from './admin-dashboard/system-info/system-info.component';
import { KundekortComponent } from './admin-dashboard/kunde-kort/kunde-kort.component';
import { MyTasksComponent } from './admin-dashboard/my-tasks/my-tasks.component';
import { MenusComponent } from './stocking/menus/menus.component';
import { SystemStockingConfigComponent } from './stocking/system-stocking-config/system-stocking-config.component';
import { ProductTypesComponent } from './stocking/product-types/product-types.component';
import { ExtraDeliveryComponent } from './stocking/extra-delivery/extra-delivery.component';
import { EmailComponent } from './admin-setting/email/email.component';
import { SimListComponent } from './support/sim-list/sim-list.component';
import { ShellComponent } from './support/shell/shell.component';
import { MakeListproductComponent } from './stocking/make-listproduct/make-listproduct.component';
import { InventoryDetailsComponent } from './admin-dashboard/inventory-details/inventory-details.component';
import { MenuComponent } from './stocking/menus/menu/menu.component';
import { PendingChangesGuard } from './stocking/menus/menu/pending-changes.guard';
import { ServicePopupComponent } from './support/service-popup/service-popup.component';
import { GrafanaReportOrdersComponent } from './reports/grafana-report-orders/grafana-report-orders.component';
import { GrafanaSupportDashboardsComponent } from './reports/grafana-support-dashboards/grafana-support-dashboards.component';
import { AuthenticatedIframeWrapperComponent } from './shared/authenticated-iframe-wrapper/authenticated-iframe-wrapper.component';
import { SystemPosterComponent } from './system-poster/system-poster.component';
import { AlarmListComponent } from './support/alarm-list/alarm-list.component';
import { CouponsListComponent } from './coupons/coupons-list/coupons-list.component';
import { SystemListComponent } from './system-list/system-list.component';

const appRoutes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'poster', component: SystemPosterComponent, data: { breadcrumb: "poster" }, canActivate: [AuthGaurd] },
    { path: 'support/shell/:systemId', component: ServicePopupComponent, data: { breadcrumb: "shell" }, canActivate: [AuthGaurd] },
    {
        path: 'dashboard', component: SidebarComponent, canActivate: [AuthGaurd]
        , children: [{
            path: '', component: AdminDashboardComponent, canActivate: [AuthGaurd], children: [
                { path: '', redirectTo: 'sites', pathMatch: 'full' },
                { path: 'system-list', component: SystemListComponent },
                { path: 'alarm-list', component: AlarmListComponent, canActivate: [AuthGaurd], data: { tab: "Alarms" } },
                { path: 'grafana-orders', component: GrafanaReportOrdersComponent, canActivate: [AuthGaurd] },
                { path: 'grafana-support', component: GrafanaSupportDashboardsComponent, canActivate: [AuthGaurd] },
                { path: 'alertmanager', component: AuthenticatedIframeWrapperComponent, canActivate: [AuthGaurd], data: { src: 'https://main.friggkantine.no/service/alertmanager/', height: '2000px', width: '100%' } },
                { path: 'category', canActivate: [AuthGaurd], component: CategoryComponent },
                { path: 'overview', canActivate: [AuthGaurd], component: OverviewComponent },
                { path: 'overview/:companyId/:siteId/:systemId', canActivate: [AuthGaurd], component: KantineOverviewComponent, data: { tab: "kantineoverview" } },
                {
                    path: 'products', component: ProductComponent, data: { breadcrumb: "Products" }, canActivate: [AuthGaurd]

                },
                {
                    path: 'regulering', component: ReguleringComponent, data: { breadcrumb: "Regulering" }, canActivate: [AuthGaurd]

                },
                {
                    path: 'sites', component: CompanySitesLayoutComponent, data: { breadcrumb: "sites" }, canActivate: [AuthGaurd],
                    children: [
                        { path: '', component: CompanySitesListComponent, canActivate: [AuthGaurd], data: { tab: "Systems" } }]
                },
                {
                    path: 'sites/:siteId', component: DetailSiteLayoutComponent, data: { breadcrumb: "sites" }, canActivate: [AuthGaurd],
                    children: [

                        { path: '', component: DetailSiteComponent, data: { tab: "Systems" }, canActivate: [AuthGaurd] },
                        {
                            path: 'report', component: ReportGeneratorComponent, data: { tab: "Report" }, children: [
                                { path: 'generate', component: ReportGeneratorResultComponent, canActivate: [AuthGaurd] },
                            ]
                        },

                        { path: 'membership-test', component: MembershipV2Component, data: { tab: "User & Group Management" }, canActivate: [AuthGaurd] },

                        { path: 'categories', component: SiteCategoryComponent, data: { tab: "Category" }, canActivate: [AuthGaurd] },
                        { path: 'special-prices', component: SpecialPricesComponent, data: { tab: "Special Prices" }, canActivate: [AuthGaurd] },
                    ]
                },
                {
                    path: 'sites/:siteId/system', component: SiteSystemLayoutComponent, canActivate: [AuthGaurd],

                    children: [

                        {
                            path: ':systemId/records', component: RecordsComponent, canActivate: [AuthGaurd], data: { tab: "Records" },
                            children: [
                                { path: 'actions', component: ActionLog, canActivate: [AuthGaurd], data: { tab: "Actions" } },
                                { path: 'machinelogs', component: MachineLog, canActivate: [AuthGaurd], data: { tab: "Machine Logs" } },


                                {
                                    path: 'transactions', component: TransactionViewComponent, canActivate: [AuthGaurd], data: { tab: "Transactions" }
                                    , children: [
                                        { path: 'generate', component: TResultViewComponent, canActivate: [AuthGaurd] },
                                    ]
                                },

                            ]
                        },

                        {
                            path: ':systemId/overview', component: SiteSystemComponent, canActivate: [AuthGaurd], data: { tab: "Overview", redirect: true },

                        },

                        {
                            path: ':systemId', component: SiteSystemComponent, canActivate: [AuthGaurd], data: { tab: "Overview", redirect: false },

                        },

                        {

                            path: ':systemId/inventory', component: InventoryComponent, canActivate: [AuthGaurd], data: { tab: "Inventory" },
                            children: [
                                { path: 'stockcontroll', component: StockcontrollComponent, canActivate: [AuthGaurd], data: { tab: "Management" } },
                                { path: 'extra-stockcontroll', component: ExtraStockcontrollComponent, canActivate: [AuthGaurd], data: { tab: "Extra Management" } },
                                { path: 'stockfiller', component: StockFillerComponent, canActivate: [AuthGaurd], data: { tab: "StockFiller" } },
                                { path: 'svinn', component: SvinnComponent, canActivate: [AuthGaurd], data: { tab: "Svinn" } },
                                { path: 'links', component: LinksComponent, canActivate: [AuthGaurd], data: { tab: "Links" } },
                            ]
                        },
                        { path: ':systemId/jsdlogs', component: JSDLog, canActivate: [AuthGaurd], data: { tab: "JSD Logs" } },

                        {
                            path: ':systemId/vmmachine/:machineid', component: VmMachineComponent, canActivate: [AuthGaurd],
                            children: [
                                { path: 'channel/:channelId', component: EditChannelComponent, canActivate: [AuthGaurd] },
                                { path: ':channelId/edit', component: EditChannelComponent, canActivate: [AuthGaurd] }
                            ]
                        }
                    ]
                }

            ]


        },
        {
            path: 'menus', component: MenuComponent, data: { breadcrumb: "stocking" }, canActivate: [AuthGaurd], canDeactivate: [PendingChangesGuard], children: [
                { path: ':year/:week', component: MenuComponent, canActivate: [AuthGaurd], canDeactivate: [PendingChangesGuard] },
            ]
        },
        { path: 'make-productlist', component: MakeListproductComponent, data: { breadcrumb: "stocking" }, canActivate: [AuthGaurd] },

        { path: 'system-stocking-config', component: SystemStockingConfigComponent, data: { breadcrumb: "menus" }, canActivate: [AuthGaurd] },
        { path: 'product-types', component: ProductTypesComponent, data: { breadcrumb: "stocking" }, canActivate: [AuthGaurd] },
        { path: 'extra-delivery', component: ExtraDeliveryComponent, data: { breadcrumb: "menus" }, canActivate: [AuthGaurd] },
        { path: 'inventory-details', component: InventoryDetailsComponent, canActivate: [AuthGaurd], data: { breadcrumb: "Inventory Details" } },

        { path: 'setting', component: SettingComponent, data: { breadcrumb: "setting" }, canActivate: [AuthGaurd] },
        { path: 'task', component: ScheduledTaskComponent, data: { breadcrumb: "task" }, canActivate: [AuthGaurd] },
        { path: 'admin', component: AdminSettingComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'email', component: EmailComponent, data: { breadcrumb: "email" }, canActivate: [AuthGaurd] },
        { path: 'orders', component: OrdersComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'planner', component: SvinnReportComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'filling', component: PlannerComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'ordersreport', component: OrderReportComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
    { path: 'revenuereport', component: RevenueReportComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'salesreport', component: SalesReportComponent, data: { tab: "Sales" }, canActivate: [AuthGaurd] },
        { path: 'salereportgenerate', component: SaleReportGeneratorResultComponent, canActivate: [AuthGaurd] },
        {
            path: 'companyreport', component: CompanyReportGeneratorComponent, data: { tab: "Report" }, children: [
                { path: 'companyreportgenerate', component: CompanyReportGeneratorResultComponent, canActivate: [AuthGaurd] },
            ]
        },
        {
            path: 'reports', component: ReportsComponent, data: { tab: "Reports" }, children: [

            ]
        },
        { path: 'kampanje', component: KampanjeListComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'announcement', component: AnnouncementListComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },



        { path: 'notification', component: NotificationListComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },

        { path: 'systeminfo', component: SystemInfoComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'kundekort', component: KundekortComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'contacts', component: ContactBookComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'employees', component: EmployeesGlobalComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'customer-mapping', component: CustomerMappingComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'billing', component: BillingComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'poweroffice-log', component: PowerOfficeLogComponent, data: { breadcrumb: "powerOfficeLog" }, canActivate: [AuthGaurd] },
        { path: 'portal-access', component: PortalAccessComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'parent-refunds', component: ParentRefundsComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'delivery/overview', component: DeliveryOverviewComponent, data: { breadcrumb: "Delivery today" }, canActivate: [AuthGaurd] },
        { path: 'delivery/routes', component: DeliveryRoutesComponent, data: { breadcrumb: "Routes" }, canActivate: [AuthGaurd] },
        { path: 'delivery/dispatch', component: DeliveryDispatchComponent, data: { breadcrumb: "Dispatch" }, canActivate: [AuthGaurd] },
        { path: 'delivery/issues', component: DeliveryIssuesComponent, data: { breadcrumb: "Issues" }, canActivate: [AuthGaurd] },
        { path: 'delivery/drivers', component: DeliveryDriversComponent, data: { breadcrumb: "driverManager" }, canActivate: [AuthGaurd] },
        { path: 'audit-logs', component: AuditLogsComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'kiosk-tablets', component: KioskTabletsComponent, data: { breadcrumb: "Kiosk tablets" }, canActivate: [AuthGaurd] },
        { path: 'my-tasks', component: MyTasksComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'coupons', component: CouponsListComponent, data: { breadcrumb: "isSuperAdmin" }, canActivate: [AuthGaurd] },
        { path: 'extra-delivery', component: ExtraDeliveryComponent, data: { breadcrumb: "menus" }, canActivate: [AuthGaurd] },


        { path: 'support/sim-list', component: SimListComponent, data: { breadcrumb: "Sim List" }, canActivate: [AuthGaurd] },

        ]

    },

    // {path:'channels',component: ChannelListComponent },
    // { path: 'signup', component: SignupComponent },
    { path: 'signin', component: SigninComponent },
    { path: 'forgot', component: ForgotComponent },
    { path: 'help', component: HelpComponentComponent, canActivate: [AuthGaurd] },
    { path: '**', redirectTo: '/' },
    // { path: '404', component:  },

    //{ path: 'cal8/units', component: Cal8ControlComponent },
    //{ path: 'sites/:siteId/system/:systemId/addunit/:id', component: Cal8ControlComponent },
]
@NgModule({
    imports: [RouterModule.forRoot(appRoutes, {
        // useHash: true,
        paramsInheritanceStrategy: 'always'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {

}